import { render, staticRenderFns } from "./Grinded.vue?vue&type=template&id=9872e19a&scoped=true&"
import script from "./Grinded.vue?vue&type=script&lang=js&"
export * from "./Grinded.vue?vue&type=script&lang=js&"
import style0 from "./Grinded.vue?vue&type=style&index=0&id=9872e19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9872e19a",
  null
  
)

export default component.exports